import { useLocation, useParams } from 'react-router-dom';

import SemenOverview from '../../features/semen/layouts/overview';
import SemenDetail from '../../features/semen/layouts/detail';
import SemenStats from '../../features/semen/layouts/stats';
import CreateSemenForm from '../../features/semen/forms/create';
import EditSemenForm from '../../features/semen/forms/edit';

// TSS vite/01 §"Pages are thin".
export default function SemenPage() {
    const { id } = useParams();
    const { pathname } = useLocation();

    if (pathname.endsWith('/new')) return <CreateSemenForm />;
    if (id && pathname.endsWith('/edit')) return <EditSemenForm semenId={id} />;
    if (id && pathname.endsWith('/stats')) return <SemenStats semenId={id} />;
    if (id) return <SemenDetail semenId={id} />;
    return <SemenOverview />;
}
